module.exports = __webpack_public_path__ + "img/report.172ed9ee.svg";